import { Component } from '@angular/core';
import { CustomDataSetService } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'fgb-my-renewals-page',
  templateUrl: './my-renewals-page.component.html',
  styleUrl: './my-renewals-page.component.scss',
})
export class MyRenewalsPageComponent {
  url$: any;
  showButton: boolean = true;
  constructor(
    private customDataSetService: CustomDataSetService,
    private translate: TranslateService
  ) {}
  dataId: number = 1;

  ngOnInit() {
    this.getCustomDataUrl();
  }

  getCustomDataUrl() {
    this.customDataSetService.GetCustomDataSet(this.dataId).subscribe((data: any) => {
      this.url$ = data[0];
      if (data[0].ErrorNumber === 0) {
        this.showButton = false;
        this.url$.title = data[0].welcome_message;
      } else this.url$.title = this.translate.instant('no.renewals.placeholder');
    });
  }
}
